var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeafs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustraciones",
    clipPath: "url(#clip0_705_50353)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M52.1638 81.7259C41.8759 29.9181 75.5332 14.1094 75.5332 14.1094C75.5332 14.1094 103.677 40.8825 75.5332 84.7402L52.1664 81.7259H52.1638Z",
    fill: "#FDAD3B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M78.0505 17.006C76.5704 15.0976 75.5306 14.1094 75.5306 14.1094C75.5306 14.1094 41.8733 29.9181 52.1638 81.7259L59.3482 82.654C42.0713 42.2812 78.0505 17.0086 78.0505 17.0086V17.006Z",
    fill: "#E7803F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.64528 99.9999C0.625083 99.9999 -0.657001 96.1281 1.77427 94.3295C9.88372 88.327 25.9671 79.7129 51.4889 79.7129C77.0107 79.7129 92.0987 88.4238 99.356 94.4288C101.623 96.3059 100.297 99.9973 97.3573 99.9973H3.64528V99.9999Z",
    fill: "#FFE177"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M26.3215 1.90292C19.6296 10.8857 5.83681 36.885 22.3423 73.3181C22.3423 73.3181 30.9026 88.8523 34.2746 88.4863C37.6466 88.1203 39.6479 81.9976 39.6479 81.9976C39.6479 81.9976 40.9221 78.1598 44.6564 81.5401C48.3906 84.9204 49.8472 86.1099 51.3039 85.7439C52.7606 85.3779 52.943 85.1034 53.855 82.9126C54.7671 80.7218 59.7756 70.1207 59.3195 52.9421C59.3195 52.9421 60.4218 23.2828 33.0681 1.05066C30.9886 -0.640799 27.9241 -0.248653 26.3215 1.90292Z",
    fill: "#03CA96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M31.5723 13.5C36.0622 33.2616 39.158 53.3369 40.8023 73.5376C36.302 53.7787 33.227 33.6982 31.5723 13.5Z",
    fill: "#0E9C7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M73.4381 90.954C74.2426 90.954 74.8948 90.2998 74.8948 89.4926C74.8948 88.6855 74.2426 88.0312 73.4381 88.0312C72.6336 88.0312 71.9814 88.6855 71.9814 89.4926C71.9814 90.2998 72.6336 90.954 73.4381 90.954Z",
    fill: "#E7803F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M73.4381 95.705C74.2426 95.705 74.8948 95.0507 74.8948 94.2436C74.8948 93.4365 74.2426 92.7822 73.4381 92.7822C72.6336 92.7822 71.9814 93.4365 71.9814 94.2436C71.9814 95.0507 72.6336 95.705 73.4381 95.705Z",
    fill: "#E7803F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M78.0818 93.8769C78.8863 93.8769 79.5384 93.2226 79.5384 92.4155C79.5384 91.6084 78.8863 90.9541 78.0818 90.9541C77.2773 90.9541 76.6251 91.6084 76.6251 92.4155C76.6251 93.2226 77.2773 93.8769 78.0818 93.8769Z",
    fill: "#E7803F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M38.8948 59.7138L40.0335 69.1514C40.1065 69.7658 39.7443 70.3488 39.1606 70.5501L31.1892 73.2951C30.2902 73.6036 29.3756 72.882 29.4616 71.9331C29.7534 68.6939 31.0824 62.2784 36.9065 58.7543C37.7248 58.2576 38.7827 58.7595 38.8974 59.7112L38.8948 59.7138Z",
    fill: "#DFF6FC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M37.6257 83.0462C37.4902 83.2606 37.287 83.4227 37.0446 83.4906C36.5365 83.6344 35.6088 83.6135 34.3788 82.4031C3.75472 42.1636 33.0681 1.05359 33.0681 1.05359C30.9886 -0.63787 27.9241 -0.245723 26.3215 1.90585C19.6296 10.8886 5.83681 36.8879 22.3423 73.321C22.3423 73.321 30.9026 88.8552 34.2746 88.4892C35.5515 88.3507 36.6329 87.386 37.4824 86.2383C37.4824 86.2383 38.9573 83.9351 39.1502 83.2737C39.343 82.6096 40.5 80.7064 40.5 80.7064C40.5 80.7064 39.343 80.3326 37.6257 83.0488V83.0462Z",
    fill: "#0E9C7C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_705_50353"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeafs);
export default __webpack_public_path__ + "static/media/leafs.1bfdaf08.svg";
export { ForwardRef as ReactComponent };